import {
    Component,
    Input,
    OnInit
} from '@angular/core';
import {
    ModalController,
    ToastController
} from '@ionic/angular';
import {
    ModalActionEnum
} from '../../core/enum/modal-action.enum';
import {
    AddTimelineComponentPayload
} from './add-timeline.model';

import {
    CameraConfigComment
} from '../../config/camera.config';
import {
    UnrAuthService
} from '../../core/auth/auth.service';
import {
    UnrApiService
} from '../../core/api/api.service';
import {
    take
} from 'rxjs/operators';
import {
    Camera,
    CameraResultType
} from '@capacitor/camera';
import {
    Geolocation
} from '@awesome-cordova-plugins/geolocation/ngx';
import {
    Geoposition
} from '@awesome-cordova-plugins/geolocation/ngx';

@Component({
    selector: 'app-add-timeline',
    templateUrl: './add-timeline.page.html',
    styleUrls: ['./add-timeline.page.scss'],
})
export class AddTimelinePage implements OnInit {
    latitude: any;
    longitude: any;
    comment;
    uploadedImages: string[] = [];
    uploading: boolean = false
    constructor(private modalController: ModalController,
        private unrAuthService: UnrAuthService,
        private unrApiService: UnrApiService,
        private toastController: ToastController, private geoLocation: Geolocation) {
        this.geoLocation.getCurrentPosition().then((position: Geoposition) => {
            if (position.coords) {
                this.latitude = position.coords.latitude;
                this.longitude = position.coords.longitude;
            }
        });
    }

    ngOnInit() {}
    cancel(): void {
        this.modalController.dismiss(undefined, ModalActionEnum.Cancel);
    }


    save(): void {
        var latitude = "";
        var longitude = "";
        var myDate = new Date().toISOString();
        if (this.latitude != undefined) {
            latitude=this.latitude.toString();
        }
        if (this.longitude != undefined) {
            longitude=this.longitude.toString();
        }
        var postdata = {
            description: this.comment,
            date: myDate,
            latitude: latitude,
            longitude: longitude,
            images: this.uploadedImages,
            firebaseUid: localStorage.getItem('uid')
        };
        console.log('mydate: ', myDate);
        this.unrApiService.postTimeline(postdata).subscribe(data => {
            this.modalController.dismiss('custom_success');
        })
    }

    removeImage(index: number): void {
        this.uploadedImages.splice(index, 1);
    }

    private async compressImage(file: File, maxWidth = 1280, quality = 0.7): Promise<Blob> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = (e: any) => {
      const img = new Image();
      img.src = e.target.result;

      img.onload = () => {
        const elem = document.createElement('canvas');

        let width = img.width;
        let height = img.height;

        // Resize maintaining aspect ratio
        if (width > maxWidth) {
          height = (maxWidth / width) * height;
          width = maxWidth;
        }

        elem.width = width;
        elem.height = height;

        const ctx = elem.getContext('2d');
        ctx.drawImage(img, 0, 0, width, height);

        // Convert to compressed Blob
        elem.toBlob(
          (blob) => {
            if (blob) resolve(blob);
            else reject('Compression failed');
          },
          'image/jpeg',
          quality
        );
      };
    };

    reader.readAsDataURL(file);
  });
}


       files: FileList | undefined;
async testup(event: any) {
  const files: FileList = event.target.files;
  if (!files || files.length === 0) return;

  for (let i = 0; i < files.length; i++) {
    const file = files[i];

    try {
      this.uploading = true;

      // ⬇️ COMPRESS HERE
      const compressedBlob = await this.compressImage(file, 1280, 0.7);

      const result = await this.unrApiService
        .uploadImage(compressedBlob, localStorage.getItem('uid'))
        .pipe(take(1))
        .toPromise();

      this.addImage(result.body);

    } catch (err) {
      const toast = await this.toastController.create({
        message: 'We could not upload your image, please try again.',
        duration: 3000
      });
      await toast.present();

    } finally {
      this.uploading = false;
    }
  }

  console.log("DONE");
}


    async takePicture() {
        const cameraPhoto = await Camera.getPhoto({
            allowEditing: false,
            quality: CameraConfigComment.QUALITY,
            width: CameraConfigComment.MAX_WIDTH,
            height: CameraConfigComment.MAX_HEIGHT,
           // preserveAspectRatio: true,
            resultType: CameraResultType.DataUrl
        });
        const url = cameraPhoto.dataUrl;

        const result = await fetch(url);
        const blob = await result.blob();

        this.uploading = true;
        this.unrApiService.uploadImage(blob, localStorage.getItem('uid'))
            .pipe(
                take(1)
            )
            .subscribe(
                (result) => {
                    this.addImage(result.body);
                    this.uploading = false;
                },
                async err => {
                    const toast = await this.toastController.create({
                        message: 'We could not upload your image, please try again.',
                        duration: 3000
                    });
                    await toast.present();
                    this.uploading = false;
                })
    }

    public addImage(url: string): void {
        if (this.uploadedImages.length < 3) {
            this.uploadedImages.push(url);
        }
    }
}